import { COMPANY_INFO } from '@repo/api-contracts';
import type { ReactElement } from 'react';

const TERM_CLASS = 'text-muted-foreground';

/**
 * 링크 화면의 고객센터. 비회원은 링크에서 수정 요청·거절·취소를 하지 않는다(결정 G9). 그래서 상태마다 운영자 연락처를 함께 둔다.
 * 값의 단일 원천은 `@repo/api-contracts` 의 `COMPANY_INFO` 다.
 */
export const GuestQuoteSupport = (): ReactElement => (
  <section
    aria-label="고객센터"
    className="flex flex-col gap-5 border-t border-foreground/10 pt-8 sm:flex-row sm:items-end sm:justify-between"
  >
    <div className="flex flex-col gap-2">
      <h2 className="text-lg font-bold tracking-[-0.02em]">고객센터</h2>
      <p className="text-sm text-muted-foreground">
        견적 내용 변경·취소나 궁금한 점은 고객센터로 연락 주세요.
      </p>
    </div>
    <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
      <dt className={TERM_CLASS}>전화</dt>
      <dd>
        <a
          href={`tel:${COMPANY_INFO.phone}`}
          className="font-semibold tabular-nums underline-offset-4 hover:underline"
        >
          {COMPANY_INFO.phone}
        </a>
      </dd>
      <dt className={TERM_CLASS}>메일</dt>
      <dd>
        <a href={`mailto:${COMPANY_INFO.email}`} className="underline-offset-4 hover:underline">
          {COMPANY_INFO.email}
        </a>
      </dd>
      <dt className={TERM_CLASS}>운영 시간</dt>
      <dd>{COMPANY_INFO.consultationHours}</dd>
    </dl>
  </section>
);
